// Closing a recurring task schedules the next one -- the repeat exists because
// somebody picked a date, not because a formula fired (spec §2.3). The monthly
// summary's body shares this dialog rather than opening a second one.
import React, { useState } from 'react';
import { addDays, summaryTemplate } from '../../lib/conciergeTodoModel';

const SUMMARY_KEY = 'monthly_summary';

export default function DoneDialog({ task, today, prompts, onCancel, onSubmit, saving }) {
  const isSummary = task.template_key === SUMMARY_KEY;
  const [repeat, setRepeat] = useState(true);
  const [due, setDue] = useState(
    task.is_recurring ? addDays(today, task.interval_days || 30) : '');
  const [body, setBody] = useState(isSummary ? summaryTemplate(prompts) : '');
  // The untouched template is only headings; saving it would file an empty note.
  const bodyReady = !isSummary || (!!body.trim() && body !== summaryTemplate(prompts));
  const dueReady = !task.is_recurring || !repeat || !!due;

  const submit = (e) => {
    e.preventDefault();
    if (!bodyReady || !dueReady || saving) return;
    onSubmit({
      next_due_at: task.is_recurring && repeat ? due : null,
      summary_body: isSummary ? body : null,
    });
  };

  return (
    <form className="cn-dialog" onSubmit={submit} data-testid="done-dialog">
      <h4 className="cn-dialog__title">{task.title}</h4>
      {isSummary && (
        <label className="ae-field">
          <span className="ae-field__label">Monthly summary</span>
          <textarea className="ae-field__input" aria-label="Monthly summary" rows={10}
                    value={body} onChange={e => setBody(e.target.value)} />
        </label>
      )}
      {task.is_recurring && (
        <>
          {repeat && (
            <label className="ae-field">
              <span className="ae-field__label">Next due</span>
              <input className="ae-field__input" type="date" aria-label="Next due" value={due}
                     onChange={e => setDue(e.target.value)} />
            </label>
          )}
          <label className="cn-choice">
            <input type="checkbox" aria-label="Don't repeat" checked={!repeat}
                   onChange={() => setRepeat(v => !v)} />
            <span>Don&apos;t repeat</span>
          </label>
        </>
      )}
      <div className="cn-dialog__actions">
        <button type="submit" className="cn-btn" disabled={!bodyReady || !dueReady || saving}>Save</button>
        <button type="button" className="cn-todo__action" onClick={onCancel}>Cancel</button>
      </div>
    </form>
  );
}
